module.exports = __webpack_public_path__ + "static/media/New Customer.9fb09d71.svg";